import { Buffer } from 'buffer'
import { AES, enc } from 'crypto-js'

const _jsk = (_: any) => _

/**
 * encode a string to base64 encoding
 */
const encode = (str: string) => {
  const buff = Buffer.from(str)
  return buff.toString('base64')
}

/**
 * decodes a base64 encoded string
 */
const decode = (str: string) => {
  const buff = Buffer.from(str, 'base64')
  return buff.toString('utf-8')
}

/**
 * encrypts a string with a hash
 */
const encrypt = (str: string, key: string = _jsk('uipomj.')) => {
  return AES.encrypt(str, key.toString()).toString()
}

/**
 * decrypts a string from a certain hash
 */
const decrypt = (str: string, key: string = _jsk(encode.toString())) => {
  return AES.decrypt(str, key.toString()).toString(enc.Utf8)
}

export { encode, decode, encrypt, decrypt }
